export { default } from './Hotels'
